import React from 'react'
import MediaEdit from './MediaEdit'

const ModelLayeredMedia = ({selectedModelList}:any) => {
  return (
    <MediaEdit selectedModelList={selectedModelList}/>
  )
}

export default ModelLayeredMedia 